import { render, staticRenderFns } from "./PricepackagePricelists.vue?vue&type=template&id=3f7dd7f3"
import script from "./PricepackagePricelists.vue?vue&type=script&lang=js"
export * from "./PricepackagePricelists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports